import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { get, post } from "../library/Api";
import PulseLoader from "react-spinners/PulseLoader";
import Box from "@mui/material/Box";
import { ToastContainer, toast } from "react-toastify";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import deleteIcon from '../assets/images/delete.svg';
import { TextField, Button, MenuItem, Modal, Stack, Typography } from "@mui/material";

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import deleteIconRed from "../assets/images/delete.png";
import ignoreIcon from "../assets/images/ignore.png";
import syncIcon from "../assets/images/sync.png";
import addIcon from "../assets/images/add.png";
import redoIcon from "../assets/images/redo.png"
import ConformationModal from "../commonComponents/Modals/ConformationModal";

const AvigilonSync = () => {
  const [value, setValue] = React.useState('1');
  const [isLoading, setIsLoading] = useState(false);
  const [avigilonCustomer, setavigilonCustomer] = useState([]);
  const [missingavigilonCustomer, setmissingavigilonCustomer] = useState([]);
  const [missmatchedRfid, setmissmatchedRfid] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const [currentPage_AVG_Customer, setcurrentPage_AVG_Customer] = useState(1);
  const [totalPage_AVG_Customer, settotalPage_AVG_Customer] = useState('0');

  const [currentPage_AVG_US_Customer, setcurrentPage_AVG_US_Customer] = useState(1);
  const [totalPage_AVG_US_Customer, settotalPage_AVG_US_Customer] = useState('0');

  const [currentPage_AVG_US_Rfid, setcurrentPage_AVG_US_Rfid] = useState(1);
  const [currentPage_AVG_US_Ignored, setcurrentPage_AVG_US_Ignored] = useState(1);
  const [currentPage_AVG_US_Ignored_Rfid, setcurrentPage_AVG_US_Ignored_Rfid] = useState(1);
  const [totalPage_AVG_US_Rfid, settotalPage_AVG_US_Rfid] = useState('0');
  const [totalPage_AVG_US_Ignored_Customer, settotalPage_AVG_US_Ignored_Customer] = useState('0');
  const [totalPage_AVG_US_Ignored_Rfid, settotalPage_AVG_US_Ignored_Rfid] = useState('0');

  const [listUSRfidIgnored, setlistUSRfidIgnored] = useState([]);
  const [listUS_CustomerIgnored, setlistUS_CustomerIgnored] = useState([]);

  const [admin_id, setadmin_id] = useState('');
  const [triggerReload, settriggerReload] = useState(false);

  const [selectedRows_AV_Customer, setSelectedRows_AV_Customer] = useState([]);
  const [selectedRows_US_Customer, setSelectedRows_US_Customer] = useState([]);
  const [selectedRows_US_IgnoredCustomer, setSelectedRows_US_IgnoredCustomer] = useState([]);
  const [selectedRows_US_Rfid, setSelectedRows_US_Rfid] = useState([]);
  const [selectedRows_US_IgnoredRfid, setSelectedRows_US_IgnoredRfid] = useState([]);
  const [openCheckedIgnoreModal_AVG, setopenCheckedIgnoreModal_AVG] = useState(false)
  const [openCheckedIgnoreModal_AVG_Rfid, setopenCheckedIgnoreModal_AVG_Rfid] = useState(false)
  const [openCheckedIgnoreModal_AVG_IgnoredCustomer, setopenCheckedIgnoreModal_AVG_IgnoredCustomer] = useState(false)
  const [openCheckedIgnoreModal_AVG_IgnoredRfid, setopenCheckedIgnoreModal_AVG_IgnoredRfid] = useState(false)

  const [customerForDelete_AV_WCustomer, setCustomerForDelete_AV_WCustomer] = useState(null);
  const [isModalOpen_Delete_AV_WCustomer, setisModalOpen_Delete_AV_WCustomer] = useState(false);
  const [openCheckedIgnoreModal_AVG_MultipleDelete, setopenCheckedIgnoreModal_AVG_MultipleDelete] = useState(false)
  const [openCheckedIgnoreModal_AVG_MultipleAdd, setopenCheckedIgnoreModal_AVG_MultipleAdd] = useState(false)

  const [searchQuery, setSearchQuery] = useState('');

  const [filteredData_missingRfid, setFilteredData_missingRfid] = useState([]);
  const [filteredData_AVGCustomerList, setFilteredData_AVGCustomerList] = useState([]);
  const [filteredData_AVG_Ignored_US_customer, setFilteredData_AVG_Ignored_US_customer] = useState([]);
  const [filteredData_AVG_Ignored_US_Rfid, setFilteredData_AVG_Ignored_US_Rfid] = useState([]);
  

  const filteredDataMissingAVG = missingavigilonCustomer
  .filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // const filteredDataAVGCustomers = avigilonCustomer
  // .filter((row) =>
  //   Object.values(row).some((value) =>
  //     value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // );
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    // padding: '12px 12px',
    borderRadius: '10px',
    bgcolor: 'background.paper',
    boxShadow: 24,
  };
  useEffect(() => {
    if (missmatchedRfid && missmatchedRfid.length > 0) {
      setFilteredData_missingRfid(missmatchedRfid); 
    }
    if(avigilonCustomer && avigilonCustomer.length > 0)
    {
      setFilteredData_AVGCustomerList(avigilonCustomer);
    }
    if(listUS_CustomerIgnored && listUS_CustomerIgnored.length > 0){
      setFilteredData_AVG_Ignored_US_customer(listUS_CustomerIgnored)
    }
    if(listUSRfidIgnored && listUSRfidIgnored.length > 0){
      setFilteredData_AVG_Ignored_US_Rfid(listUSRfidIgnored)
    }
  }, [missmatchedRfid,avigilonCustomer,listUS_CustomerIgnored,listUSRfidIgnored]); 


  const rowsPerPage_AVG_Customer = 15;
  const rowsPerPage_AVG_US_Customer = 15;
  const rowsPerPage_AVG_US_Rfid = 15;

  const rowsPerPage_AVG_US_Ignored_Customer =6;
  const rowsPerPage_AVG_US_Ignored_Rfid =6;

  // Calculate start and end index for the AVG customers
  const startIndex_AVG_Customer = (currentPage_AVG_Customer - 1) * rowsPerPage_AVG_Customer + 1;
  const endIndex_AVG_Customer = Math.min(currentPage_AVG_Customer * rowsPerPage_AVG_Customer, filteredData_AVGCustomerList.length);
  // const endIndex_AVG_Customer = Math.min(currentPage_AVG_Customer * rowsPerPage_AVG_Customer, avigilonCustomer.length);

  // Calculate start and end index for the UnSynced AVG customers
  const startIndex_AVG_US_Customer = (currentPage_AVG_US_Customer - 1) * rowsPerPage_AVG_US_Customer + 1;
  const endIndex_AVG_US_Customer = Math.min(currentPage_AVG_US_Customer * rowsPerPage_AVG_US_Customer, filteredDataMissingAVG.length);

  // Calculate start and end index for the UnSynced AVG Rfid
  const startIndex_AVG_US_Rfid = (currentPage_AVG_US_Rfid - 1) * rowsPerPage_AVG_US_Rfid + 1;
  const endIndex_AVG_US_Rfid = Math.min(currentPage_AVG_US_Rfid * rowsPerPage_AVG_US_Rfid, filteredData_missingRfid.length);
  // const endIndex_AVG_US_Rfid = Math.min(currentPage_AVG_US_Rfid * rowsPerPage_AVG_US_Rfid, missmatchedRfid.length);

    // Calculate start and end index for the UnSynced AVG Ignored customer
    const startIndex_AVG_US_Ignored_Customer = (currentPage_AVG_US_Ignored - 1) * rowsPerPage_AVG_US_Ignored_Customer + 1;
    const endIndex_AVG_US_Ignored_Customer = Math.min(currentPage_AVG_US_Ignored * rowsPerPage_AVG_US_Ignored_Customer, filteredData_AVG_Ignored_US_customer.length);
    // const endIndex_AVG_US_Ignored_Customer = Math.min(currentPage_AVG_US_Ignored * rowsPerPage_AVG_US_Ignored_Customer, listUS_CustomerIgnored.length);

    // Calculate start and end index for the UnSynced AVG Ignored customer
    const startIndex_AVG_US_Ignored_Rfid = (currentPage_AVG_US_Ignored_Rfid - 1) * rowsPerPage_AVG_US_Ignored_Rfid + 1;
    const endIndex_AVG_US_Ignored_Rfid = Math.min(currentPage_AVG_US_Ignored_Rfid * rowsPerPage_AVG_US_Ignored_Rfid, filteredData_AVG_Ignored_US_Rfid.length);
    // const endIndex_AVG_US_Ignored_Rfid = Math.min(currentPage_AVG_US_Ignored_Rfid * rowsPerPage_AVG_US_Ignored_Rfid, listUSRfidIgnored.length);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setcurrentPage_AVG_Customer(1);
    setcurrentPage_AVG_US_Customer(1);
    setcurrentPage_AVG_US_Rfid(1);
    setSelectedRows_AV_Customer([]);
    setSelectedRows_US_Customer([]);
    setSelectedRows_US_Rfid([]);
    setSelectedRows_US_IgnoredCustomer([]);
    setSelectedRows_US_IgnoredRfid([]);
    setSearchQuery("");
    setcurrentPage_AVG_US_Ignored(1);
    setcurrentPage_AVG_US_Ignored_Rfid(1);
     
    if (missmatchedRfid && missmatchedRfid.length > 0) {
      setFilteredData_missingRfid(missmatchedRfid);
    } else {
     
      setFilteredData_missingRfid([]); 
    }

    if (avigilonCustomer && avigilonCustomer.length > 0) {
      setFilteredData_AVGCustomerList(avigilonCustomer);
    } else {
     
      setFilteredData_AVGCustomerList([]); 
    }
    if (listUS_CustomerIgnored && listUS_CustomerIgnored.length > 0) {
      setFilteredData_AVG_Ignored_US_customer(listUS_CustomerIgnored);
    } else {
     
      setFilteredData_AVG_Ignored_US_customer([]); 
    }
    if (listUSRfidIgnored && listUSRfidIgnored.length > 0) {
      setFilteredData_AVG_Ignored_US_Rfid(listUSRfidIgnored);
    } else {
     
      setFilteredData_AVG_Ignored_US_Rfid([]); 
    }

  };
  const buttonStyle = {
    fontSize: '0.875rem', // Adjust button text size
    padding: '6px 12px', // Adjust button padding for smaller size
  };



  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id = mcdata.admin_id
    setadmin_id(tempadmin_id)
  }, []);


  useEffect(() => {
    const fetchAvigilonCustomerData = async () => {
      try {
        setIsLoading(true);
  
        // Fetch data from the new API
        const res = await get("list_avigilon_customer");
        const customers = res.data.customers;
  
        // Update state with new data
        setavigilonCustomer(customers);
        setFilteredData_AVGCustomerList(customers)
  
        // Calculate total pages
        const totalPages = Math.ceil(customers.length / rowsPerPage_AVG_Customer);
        settotalPage_AVG_Customer(totalPages);
        
      } catch (error) {
        console.error("Error fetching customer data:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchAvigilonCustomerData();
  
    // Dependency array ensures fetch only runs when triggerReload changes
  }, [triggerReload]);
  

  // useEffect(() => {
  //   setIsLoading(true);

  //   // Fetch data from the new API
  //   get("list_missing_avigilon_customer")
  //     .then((res) => {
  //       setmissingavigilonCustomer(res.data.missing_customers); // Update with the new data structure
  //       // const missingAvgCustomers_res = res.data.missing_customers;

  //       // const temp_totalPages = Math.ceil(filteredDataMissingAVG.length / rowsPerPage_AVG_US_Customer);
  //       // settotalPage_AVG_US_Customer(temp_totalPages)


  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching customer data:", error);
  //       setIsLoading(false);
  //     });
  // }, [triggerReload]);

  useEffect(() => {
    const fetchMissingAvigilonCustomers = async () => {
      try {
        setIsLoading(true);
  
        // Fetch data from the API
        const response = await get("list_missing_avigilon_customer");
  
        // Update state with the new data
        setmissingavigilonCustomer(response.data.missing_customers);
         // const missingAvgCustomers_res = res.data.missing_customers;
  
        // Pagination logic (uncomment and adjust as needed)
        // const totalPages = Math.ceil(filteredDataMissingAVG.length / rowsPerPage_AVG_US_Customer);
        // settotalPage_AVG_US_Customer(totalPages);
        
      } catch (error) {
        console.error("Error fetching customer data:", error);
      } finally {
        // Ensure loading is set to false after the API call
        setIsLoading(false);
      }
    };
  
    fetchMissingAvigilonCustomers();
  
  }, [triggerReload]);
  

  // UseEffect to calculate total pages based on filtered data
useEffect(() => {
  const temp_totalPages = Math.ceil(filteredDataMissingAVG.length / rowsPerPage_AVG_US_Customer);
  settotalPage_AVG_US_Customer(temp_totalPages);
}, [filteredDataMissingAVG, rowsPerPage_AVG_US_Customer]); // Trigger pagination logic only when filteredData or rowsPerPage changes

// useEffect(() => {
//   const temp_totalPages = Math.ceil(filteredDataAVGCustomers.length / rowsPerPage_AVG_Customer);
//   setcurrentPage_AVG_Customer(temp_totalPages);
// }, [filteredDataAVGCustomers, rowsPerPage_AVG_Customer]); // Trigger pagination logic only when filteredData or rowsPerPage changes



  // useEffect(() => {
  //   setIsLoading(true);

  //   // Fetch data from the new API
  //   get("compare_rfid_data")
  //     .then((res) => {
  //       setmissmatchedRfid(res.data.mismatched_data); // Update with the new data structure

  //       const missingRfidCustomers_res = res.data.mismatched_data;

  //       const temp_totalPages = Math.ceil(missingRfidCustomers_res.length / rowsPerPage_AVG_US_Rfid);
  //       settotalPage_AVG_US_Rfid(temp_totalPages)
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching customer data:", error);
  //       setIsLoading(false);
  //     });
  // }, [triggerReload]);

  useEffect(() => {
    const fetchMismatchedRfidData = async () => {
      try {
        setIsLoading(true);
  
        // Fetch data from the new API
        const { data } = await get("compare_rfid_data");
  
        // Update state with the new data structure
        setmissmatchedRfid(data.mismatched_data);
        setFilteredData_missingRfid(data.mismatched_data);
  
        // Calculate total pages for pagination
        const totalPages = Math.ceil(data.mismatched_data.length / rowsPerPage_AVG_US_Rfid);
        settotalPage_AVG_US_Rfid(totalPages);
  
      } catch (error) {
        console.error("Error fetching RFID data:", error);
      } finally {
        // Ensure the loading state is reset after API call
        setIsLoading(false);
      }
    };
  
    fetchMismatchedRfidData();
  
  }, [triggerReload]);

  // UseEffect to handle search filtering and pagination update missing rfid
useEffect(() => {
  let filtered = [];

  if (value === '1')
  {
    filtered = avigilonCustomer.filter((row) =>
      Object.values(row).some((value) =>
        value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  
    setFilteredData_AVGCustomerList(filtered); // Update filtered data
    setcurrentPage_AVG_Customer(1); // Reset to first page when search changes
  
    // Update total pages based on filtered data
    const totalPages = Math.ceil(filtered.length / rowsPerPage_AVG_Customer);
    settotalPage_AVG_Customer(totalPages);
  }
  if (value === '3')
  {
  filtered = missmatchedRfid.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  setFilteredData_missingRfid(filtered); // Update filtered data
  setcurrentPage_AVG_US_Rfid(1); // Reset to first page when search changes

  // Update total pages based on filtered data
  const totalPages = Math.ceil(filtered.length / rowsPerPage_AVG_US_Rfid);
  settotalPage_AVG_US_Rfid(totalPages);
}
if (value === '4' && expanded === 'panel1'){
  filtered = listUS_CustomerIgnored.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  setFilteredData_AVG_Ignored_US_customer(filtered); // Update filtered data
  setcurrentPage_AVG_US_Ignored(1); // Reset to first page when search changes

  // Update total pages based on filtered data
  const totalPages = Math.ceil(filtered.length / rowsPerPage_AVG_US_Ignored_Customer);
  settotalPage_AVG_US_Ignored_Customer(totalPages);

}
if (value === '4' && expanded === 'panel2'){
  filtered = listUSRfidIgnored.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  setFilteredData_AVG_Ignored_US_Rfid(filtered); // Update filtered data
  setcurrentPage_AVG_US_Ignored_Rfid(1); // Reset to first page when search changes

  // Update total pages based on filtered data
  const totalPages = Math.ceil(filtered.length / rowsPerPage_AVG_US_Ignored_Rfid);
  settotalPage_AVG_US_Ignored_Rfid(totalPages);

}
}, [searchQuery, missmatchedRfid,avigilonCustomer,listUS_CustomerIgnored,listUSRfidIgnored]);
  


  useEffect(() => {
    const fetchRfidIgnoredData = async () => {
      setIsLoading(true);
      try {
        const response = await get(`listignoreavigiloncustomer?rfid_unsync=True`);
        setlistUSRfidIgnored(response.data.customers);
        setFilteredData_AVG_Ignored_US_Rfid(response.data.customers)
        const missingUS_IgnoredRfid_res = response.data.customers;
        const temp_totalPages = Math.ceil(response.data.customers.length / rowsPerPage_AVG_US_Ignored_Rfid);
        settotalPage_AVG_US_Ignored_Rfid(temp_totalPages)
       
      } catch (error) {
        console.error('Error fetching RFID ignored data:', error);
      } finally {
        setIsLoading(false); // Always set loading to false regardless of success or failure
      }
    };

    // Call the async function
    fetchRfidIgnoredData();

    // Cleanup function in case the component unmounts during the request
    return () => {
      setIsLoading(false); // Clean up the loading state if the component unmounts
    };
  }, [triggerReload]);

  useEffect(() => {
    const fetchAVG_US_CustomerIgnoredData = async () => {
      setIsLoading(true);
      try {
        const response = await get(`listignoreavigiloncustomer?customer_unsync=True`);
        setlistUS_CustomerIgnored(response.data.customers);
        setFilteredData_AVG_Ignored_US_customer(response.data.customers)
        const missingUS_IgnoredCustomers_res = response.data.customers;
        const temp_totalPages = Math.ceil(response.data.customers.length / rowsPerPage_AVG_US_Ignored_Customer);
        settotalPage_AVG_US_Ignored_Customer(temp_totalPages)
      } catch (error) {
        console.error('Error fetching RFID ignored data:', error);
      } finally {
        setIsLoading(false); // Always set loading to false regardless of success or failure
      }
    };

    // Call the async function
    fetchAVG_US_CustomerIgnoredData();

    // Cleanup function in case the component unmounts during the request
    return () => {
      setIsLoading(false); // Clean up the loading state if the component unmounts
    };
  }, [triggerReload]);

  const handle_US_CustomerIgnoreFunction = async (avigilon_id, ignore_type) => {

    const ignore_api_AVG = "avigilonignorecustomer";


    var data = {
      avigiloncustomer_id: avigilon_id,
      ignore_type: ignore_type,
      admin_id: admin_id
    }

    try {

      const response = await post(ignore_api_AVG, data);

      const { status } = response;

      if (status === 200) {
        toast.success("Customer ignored successfully", {
          autoClose: 500,
        });
        settriggerReload(!triggerReload)
      } else {
        toast.error("Failed to ignore customer", {
          autoClose: 500,
        });
      }
    } catch (error) {
      console.error("Ignore Error:", error);
      toast.error(`Error: ${error.message || "Something went wrong"}`, {
        autoClose: 500,
      });
    }
  }

  const handle_US_RfidIgnoreFunction = async (avigilon_id, ignore_type) => {

    const ignore_api_AVG = "avigilonignorecustomer";


    var data = {
      avigiloncustomer_id: avigilon_id,
      ignore_type: ignore_type,
      admin_id: admin_id
    }

    try {

      const response = await post(ignore_api_AVG, data);

      const { status } = response;

      if (status === 200) {
        toast.success("Customer ignored successfully", {
          autoClose: 500,
        });
        settriggerReload(!triggerReload)
      } else {
        toast.error("Failed to ignore customer", {
          autoClose: 500,
        });
      }
    } catch (error) {
      console.error("Ignore Error:", error);
      toast.error(`Error: ${error.message || "Something went wrong"}`, {
        autoClose: 500,
      });
    }
  }

  const handleRedoUS_CustomerFunction = async (avigilon_id, ignore_type) => {
    setIsLoading(true);

    const ignore_api_AVG = "avigilonredocustomer";


    var data = {
      avigiloncustomer_id: avigilon_id,
      ignore_type: ignore_type,
      admin_id: admin_id
    }

    try {

      const response = await post(ignore_api_AVG, data);

      const { status } = response;

      if (status === 200) {
        toast.success("Customer restored  successfully", {
          autoClose: 500,
        });
        settriggerReload(!triggerReload)
        // setIsLoading(false);
      } else {
        toast.error("Failed to Redo customer", {
          autoClose: 500,
        });
      }
    } catch (error) {
      console.error("Ignore Error:", error);
      toast.error(`Error: ${error.message || "Something went wrong"}`, {
        autoClose: 500,
      });
    } finally {
      setIsLoading(false); // Always reset loading state regardless of success or error
    }
  }

  const handleRedoUS_RfidFunction = async (avigilon_id, ignore_type) => {
    setIsLoading(true);

    const ignore_api_AVG = "avigilonredocustomer";


    var data = {
      avigiloncustomer_id: avigilon_id,
      ignore_type: ignore_type,
      admin_id: admin_id
    }

    try {

      const response = await post(ignore_api_AVG, data);

      const { status } = response;

      if (status === 200) {
        toast.success("Customer Redo successfully", {
          autoClose: 500,
        });
        settriggerReload(!triggerReload)
        // setIsLoading(false);
      } else {
        toast.error("Failed to Redo customer", {
          autoClose: 500,
        });
      }
    } catch (error) {
      console.error("Ignore Error:", error);
      toast.error(`Error: ${error.message || "Something went wrong"}`, {
        autoClose: 500,
      });
    } finally {
      setIsLoading(false); // Always reset loading state regardless of success or error
    }
  }



  // Handle expand/collapse
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setSelectedRows_US_IgnoredCustomer([]);
    setSelectedRows_US_IgnoredRfid([]);
  };

  // For pagination tab1
  const handleNextPage_AVG_Customer = () => {
    if (currentPage_AVG_Customer < totalPage_AVG_Customer) {
      setcurrentPage_AVG_Customer(currentPage_AVG_Customer + 1);
    }
  };

  const handlePreviousPage_AVG_Customer = () => {
    if (currentPage_AVG_Customer > 1) {
      setcurrentPage_AVG_Customer(currentPage_AVG_Customer - 1);
    }
  }

  // For pagination tab2
  const handleNextPage_AVG_US_Customer = () => {
    if (currentPage_AVG_US_Customer < totalPage_AVG_US_Customer) {
      setcurrentPage_AVG_US_Customer(currentPage_AVG_US_Customer + 1);
    }
  };

  const handlePreviousPage_AVG_US_Customer = () => {
    if (currentPage_AVG_US_Customer > 1) {
      setcurrentPage_AVG_US_Customer(currentPage_AVG_US_Customer - 1);
    }
  };

  // For pagination tab3
  const handleNextPage_AVG_US_Rfid = () => {
    if (currentPage_AVG_US_Rfid < totalPage_AVG_US_Rfid) {
      setcurrentPage_AVG_US_Rfid(currentPage_AVG_US_Rfid + 1);
    }
  };

  const handlePreviousPage_AVG_US_Rfid = () => {
    if (currentPage_AVG_US_Rfid > 1) {
      setcurrentPage_AVG_US_Rfid(currentPage_AVG_US_Rfid - 1);
    }
  };

  const handleNextPage_AVG_US_Ignored_Customer = () => {
    if (currentPage_AVG_US_Ignored < totalPage_AVG_US_Ignored_Customer) {
      setcurrentPage_AVG_US_Ignored(currentPage_AVG_US_Ignored + 1);
    }
  };

  const handlePreviousPage_AVG_US_Ignored_Customer = () => {
    if (currentPage_AVG_US_Ignored > 1) {
      setcurrentPage_AVG_US_Ignored(currentPage_AVG_US_Ignored - 1);
    }
  };

  const handleNextPage_AVG_US_Ignored_Rfid = () => {
    if (currentPage_AVG_US_Ignored_Rfid < totalPage_AVG_US_Ignored_Rfid) {
      setcurrentPage_AVG_US_Ignored_Rfid(currentPage_AVG_US_Ignored_Rfid + 1);
    }
  };

  const handlePreviousPage_AVG_US_Ignored_Rfid = () => {
    if (currentPage_AVG_US_Ignored_Rfid > 1) {
      setcurrentPage_AVG_US_Ignored_Rfid(currentPage_AVG_US_Ignored_Rfid - 1);
    }
  };

  // Function to handle checkbox changes w/o Ignored Rfid Redo
  const handleCheckboxChange_AV_Customer = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_AV_Customer([...selectedRows_AV_Customer, customerId]); // Add selected customer_id
    } else {
      setSelectedRows_AV_Customer(selectedRows_AV_Customer.filter(id => id !== customerId)); // Remove deselected customer_id
    }

  };


  const handleCheckboxChange_US_Customer = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_US_Customer([...selectedRows_US_Customer, customerId]);
    } else {
      setSelectedRows_US_Customer(selectedRows_US_Customer.filter(id => id !== customerId));
    }

  };

  const handleCheckboxChange_US_IgnoredCustomer = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_US_IgnoredCustomer([...selectedRows_US_IgnoredCustomer, customerId]);
    } else {
      setSelectedRows_US_IgnoredCustomer(selectedRows_US_IgnoredCustomer.filter(id => id !== customerId));
    }
  };

  const handleCheckboxChange_US_IgnoredRfid = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_US_IgnoredRfid([...selectedRows_US_IgnoredRfid, customerId]);
    } else {
      setSelectedRows_US_IgnoredRfid(selectedRows_US_IgnoredRfid.filter(id => id !== customerId));
    }
  };



  // Function to handle multiple ignore
  const handleCheckboxChange_US_Rfid = (event, customerId) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedRows_US_Rfid([...selectedRows_US_Rfid, customerId]); // Add selected customer_id
    } else {
      setSelectedRows_US_Rfid(selectedRows_US_Rfid.filter(id => id !== customerId)); // Remove deselected customer_id
    }

  };

  const handleCheckedData_AVG = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_AVG(true)

  }

  const handleCheckedIgnoreClose_AVG = () => {
    setopenCheckedIgnoreModal_AVG(false)
  }

  const handleCheckedData_AVG_Rfid = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_AVG_Rfid(true)
  }
  const handleCheckedIgnoreClose_AVG_Rfid = () => {
    setopenCheckedIgnoreModal_AVG_Rfid(false)
  }

  const handleCheckedData_AVG_IgnoredCustomer = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_AVG_IgnoredCustomer(true)
  }
  const handleCheckedIgnoreClose_AVG_IgnoredCustomer = () => {
    setopenCheckedIgnoreModal_AVG_IgnoredCustomer(false)
  }

  const handleCheckedData_AVG_IgnoredRfid = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_AVG_IgnoredRfid(true)
  }
  const handleCheckedIgnoreClose_AVG_IgnoredRfid = () => {
    setopenCheckedIgnoreModal_AVG_IgnoredRfid(false)
  }


  const handleChecked_AVG_US_Customer_IgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultiple_AVG_IgnoreSubmit(selectedRows_US_Customer, "customer_unsync");
  }

  const handleChecked_AVG_US_Rfid_IgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultiple_AVG_IgnoreSubmit(selectedRows_US_Rfid, "rfid_unsync");
  }

  const handleChecked_AVG_US_IgnoredCustomer_IgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultiple_AVG_RedoSubmit(selectedRows_US_IgnoredCustomer, "customer_unsync");
  }

  const handleChecked_AVG_US_IgnoredRfid_IgnoreSubmit = (event) => {
    event.preventDefault();
    handleMultiple_AVG_RedoSubmit(selectedRows_US_IgnoredRfid, "rfid_unsync");
  }


  const handleMultiple_AVG_RedoSubmit = async (selectedRedoRows_US_Customer, ignoreType) => {
    let selectedCustomerData = [];
    let requestData = {};

    if (ignoreType === "customer_unsync") {
      selectedCustomerData = selectedRedoRows_US_Customer.map((avigilon_id) => {
        const customerData = listUS_CustomerIgnored.find(
          (customer) => customer.avigiloncustomer_id === avigilon_id
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${avigilon_id}`);
          return null; // Handle case where customer data is not found
        }

        return {
          avigiloncustomer_ids: customerData.avigiloncustomer_id,
          ignore_types: ignoreType,
          admin_ids: admin_id
        };
      }).filter(Boolean);
    }

    if (ignoreType === "rfid_unsync") {
      selectedCustomerData = selectedRedoRows_US_Customer.map((avigilon_id) => {
        const customerData = listUSRfidIgnored.find(
          (customer) => customer.avigiloncustomer_id === avigilon_id
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${avigilon_id}`);
          return null; // Handle case where customer data is not found
        }

        return {
          avigiloncustomer_ids: customerData.avigiloncustomer_id,
          ignore_types: ignoreType,
          admin_ids: admin_id
        };
      }).filter(Boolean);
    }

    if (selectedCustomerData.length === 0) {
      toast.error("No valid customer data found.");
      return;
    }

    requestData = {
      avigiloncustomer_ids: selectedCustomerData.map((item) => item.avigiloncustomer_ids),
      ignore_types: Array(selectedCustomerData.length).fill(ignoreType),
      admin_ids: Array(selectedCustomerData.length).fill(admin_id)
    };

    try {
      const response = await post('multipleavigilonredocustomer', requestData);

      if (response.status === 200) {
        toast.success("Selected customers were successfully redone.");
        if (ignoreType === "customer_unsync") {
          setopenCheckedIgnoreModal_AVG_IgnoredCustomer(false);
          setSelectedRows_US_IgnoredCustomer([]);
        }
        else if (ignoreType === "rfid_unsync") {
          setopenCheckedIgnoreModal_AVG_IgnoredRfid(false);
          setSelectedRows_US_IgnoredRfid([]);
        }

        else {
          toast.error("An error occurred while redoing  the customers. Please try again.");
        }
        settriggerReload(!triggerReload);
      }

    } catch (error) {
      console.error("Error while redoing customers:", error);
      toast.error("An error occurred while processing your request.");
    } finally {
      setIsLoading(false);
    }
  }

  const handleMultiple_AVG_IgnoreSubmit = async (selectedRows_US_PCustomer, ignoreType) => {
    setIsLoading(true);
    let selectedCustomerData = [];
    let requestData = {};

    if (ignoreType === "customer_unsync") {
      selectedCustomerData = selectedRows_US_PCustomer.map((avigilon_id) => {
        const customerData = missingavigilonCustomer.find(
          (customer) => customer.avigiloncustomer_id === avigilon_id
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${avigilon_id}`);
          return null; // Handle case where customer data is not found
        }

        return {
          avigiloncustomer_ids: customerData.avigiloncustomer_id,
          ignore_types: ignoreType,
          admin_ids: admin_id
        };
      }).filter(Boolean);
    }

    if (ignoreType === "rfid_unsync") {
      selectedCustomerData = selectedRows_US_PCustomer.map((avigilon_id) => {
        const customerData = missmatchedRfid.find(
          (customer) => customer.avigiloncustomer_id === avigilon_id
        );

        if (!customerData) {
          console.error(`Customer data not found for customer ID: ${avigilon_id}`);
          return null; // Handle case where customer data is not found
        }

        return {
          avigiloncustomer_ids: customerData.avigiloncustomer_id,
          ignore_types: ignoreType,
          admin_ids: admin_id
        };
      }).filter(Boolean);
    }

    if (selectedCustomerData.length === 0) {
      toast.error("No valid customer data found.");
      return;
    }

    requestData = {
      avigiloncustomer_ids: selectedCustomerData.map((item) => item.avigiloncustomer_ids),
      ignore_types: Array(selectedCustomerData.length).fill(ignoreType),
      admin_ids: Array(selectedCustomerData.length).fill(admin_id)
    };

    try {
      const response = await post('multipleavigilonignorecustomer', requestData);

      if (response.status === 200) {
        toast.success("Selected customers were successfully ignored.");
        if (ignoreType === "customer_unsync") {
          setopenCheckedIgnoreModal_AVG(false);
          setSelectedRows_US_Customer([]);
        }
        else if (ignoreType === "rfid_unsync") {
          setopenCheckedIgnoreModal_AVG_Rfid(false);
          setSelectedRows_US_Rfid([]);
        }

        else {
          toast.error("An error occurred while ignoring the customers. Please try again.");
        }
        settriggerReload(!triggerReload);
      }

    } catch (error) {
      console.error("Error while ignoring customers:", error);
      toast.error("An error occurred while processing your request.");
    } finally {
      setIsLoading(false);
    }
  }

  const handleDeleteReport_AV_WCustomer = (event, customerToDelete) => {
    event.preventDefault();
    setCustomerForDelete_AV_WCustomer(customerToDelete)
    setisModalOpen_Delete_AV_WCustomer(true)
  }

  const handleDeleteModalClose_AV_WCustomer = () => {
    setisModalOpen_Delete_AV_WCustomer(false);
  }

  const handleDelete_AVG = async (event) => {
    event.preventDefault();

    if (!customerForDelete_AV_WCustomer) return;

    const data = {
      avigiloncustomer_id: customerForDelete_AV_WCustomer.avigiloncustomer_id,
      admin_id: admin_id,
      tp_id: customerForDelete_AV_WCustomer.tp_id,
      tp_credentialid: customerForDelete_AV_WCustomer.tp_credentialid,
      tp_groupid: customerForDelete_AV_WCustomer.tp_groupid,
    };

    console.log("Data to delete:", data);

    try {
      const response = await post("delete_avigilon_customerdata", data);

      if (response.status === 200) {
        toast.success("Customer deleted successfully!", { autoClose: 500 });
        setisModalOpen_Delete_AV_WCustomer(false);
        settriggerReload(!triggerReload); // Trigger reload efficiently
      } else {
        toast.error("Failed to delete the customer. Please try again.");
      }
    } catch (error) {
      console.error("Error while deleting the customer:", error);
      toast.error("An error occurred while processing your request.");
    }
  };

  const handleCheckedData_AVG_MultipleDelete = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_AVG_MultipleDelete(true)
  }

  const handleCheckedData_AVG_MultipleAdd = (event) => {
    event.preventDefault();
    setopenCheckedIgnoreModal_AVG_MultipleAdd(true)

  }

  const handleClose_MultipleAddModal = () => {
    setopenCheckedIgnoreModal_AVG_MultipleAdd(false)
  }

  const handleDeleteModalClose_AV_MultipleDelete = () => {
    setopenCheckedIgnoreModal_AVG_MultipleDelete(false)
  }

  // const handleMultipleDelete_AVG = async  (event)=>{
  //   event.preventDefault();

  //     // Gather selected customer IDs from each state, defaulting to empty arrays if any are null/undefined
  //     const selectedCustomers = selectedRows_US_Customer || [];
  //     const selectedIgnoredCustomers = selectedRows_US_IgnoredCustomer || [];
  //     const selectedRfid = selectedRows_US_Rfid || [];
  //     const selectedIgnoredRfid = selectedRows_US_IgnoredRfid || [];

  //     // Combine all selected IDs into one payload for avigiloncustomer_ids, even if some arrays are empty
  //     const avigiloncustomer_ids = [
  //       ...selectedCustomers,
  //       ...selectedIgnoredCustomers,
  //       ...selectedRfid,
  //       ...selectedIgnoredRfid,
  //     ];


  //     const avigiloncustomer_ids_arr = [];
  //     const tp_ids_arr = [];
  //     const tp_credentialids_arr = [];
  //     const tp_groupids_arr = [];

  //     // Find customer data from the combined ids and extract individual arrays
  //     if(selectedRows_US_Customer.length>0){
  //       console.log("selectedRows_US_Customer Working")
  //     avigiloncustomer_ids.forEach((avigilon_id) => {
  //       const customerData = missingavigilonCustomer.find(
  //         (customer) => customer.avigiloncustomer_id === avigilon_id
  //       );

  //       if (!customerData) {
  //         console.error(`Customer data not found for customer ID: ${avigilon_id}`);
  //         return; // Skip if no matching data found
  //       }

  //       // Push values into respective arrays
  //       avigiloncustomer_ids_arr.push(customerData.avigiloncustomer_id);
  //       if (customerData.tp_id) tp_ids_arr.push(customerData.tp_id);
  //       if (customerData.tp_credentialid) tp_credentialids_arr.push(customerData.tp_credentialid);
  //       if (customerData.tp_groupid) tp_groupids_arr.push(...customerData.tp_groupid); // Spread tp_groupid array into tp_groupids_arr
  //     });

  //   } else if(selectedRows_US_Rfid.length>0){
  //     console.log("missmatchedRfid working")

  //     avigiloncustomer_ids.forEach((avigilon_id) => {
  //       const customerData = missmatchedRfid.find(
  //         (customer) => customer.avigiloncustomer_id === avigilon_id
  //       );

  //       if (!customerData) {
  //         console.error(`Customer data not found for customer ID: ${avigilon_id}`);
  //         return; // Skip if no matching data found
  //       }

  //       // Push values into respective arrays
  //       avigiloncustomer_ids_arr.push(customerData.avigiloncustomer_id);
  //       if (customerData.tp_id) tp_ids_arr.push(customerData.tp_id);
  //       if (customerData.tp_credentialid) tp_credentialids_arr.push(customerData.tp_credentialid);
  //       if (customerData.tp_groupid) tp_groupids_arr.push(...customerData.tp_groupid); // Spread tp_groupid array into tp_groupids_arr
  //     });

  //       }

  //       else if(selectedRows_US_IgnoredRfid.length>0){
  //         console.log("selectedRselectedRows_US_Rfid working")

  //         avigiloncustomer_ids.forEach((avigilon_id) => {
  //           const customerData = listUSRfidIgnored.find(
  //             (customer) => customer.avigiloncustomer_id === avigilon_id
  //           );

  //           if (!customerData) {
  //             console.error(`Customer data not found for customer ID: ${avigilon_id}`);
  //             return; // Skip if no matching data found
  //           }

  //           // Push values into respective arrays
  //           avigiloncustomer_ids_arr.push(customerData.avigiloncustomer_id);
  //           if (customerData.tp_id) tp_ids_arr.push(customerData.tp_id);
  //           if (customerData.tp_credentialid) tp_credentialids_arr.push(customerData.tp_credentialid);
  //           if (customerData.tp_groupid) tp_groupids_arr.push(...customerData.tp_groupid); // Spread tp_groupid array into tp_groupids_arr
  //         });

  //           }

  //           else if(selectedRows_US_IgnoredCustomer.length>0){
  //             console.log("listUS_CustomerIgnored working")

  //             avigiloncustomer_ids.forEach((avigilon_id) => {
  //               const customerData = listUS_CustomerIgnored.find(
  //                 (customer) => customer.avigiloncustomer_id === avigilon_id
  //               );

  //               if (!customerData) {
  //                 console.error(`Customer data not found for customer ID: ${avigilon_id}`);
  //                 return; // Skip if no matching data found
  //               }

  //               // Push values into respective arrays
  //               avigiloncustomer_ids_arr.push(customerData.avigiloncustomer_id);
  //               if (customerData.tp_id) tp_ids_arr.push(customerData.tp_id);
  //               if (customerData.tp_credentialid) tp_credentialids_arr.push(customerData.tp_credentialid);
  //               if (customerData.tp_groupid) tp_groupids_arr.push(...customerData.tp_groupid); // Spread tp_groupid array into tp_groupids_arr
  //             });

  //               }


  //         // Combine everything into the final payload
  //         const payload = {
  //           avigiloncustomer_ids: avigiloncustomer_ids_arr,
  //           admin_id: admin_id, // Ensure this is set properly
  //           tp_ids: tp_ids_arr,
  //           tp_credentialids: tp_credentialids_arr,
  //           tp_groupids: tp_groupids_arr,
  //         };

  //         // Log or use the payload for API call
  //         console.log("Formatted payload for multiple delete:", payload);

  //         // Call the multiple delete API
  //         try {
  //           const response = await post('multipledelete_avigilon_customerdata', payload);
  //           if (response.status === 200) {
  //             toast.success("Selected customers were successfully deleted.");
  //             // Reset the state based on the ignoreType if applicable
  //             setopenCheckedIgnoreModal_AVG_MultipleDelete(false)
  //           } else {
  //             toast.error("An error occurred while deleting the customers. Please try again.");
  //           }
  //           settriggerReload(!triggerReload);
  //         } catch (error) {
  //           console.error("Error while deleting customers:", error);
  //           toast.error("An error occurred while processing your request.");
  //         } finally {
  //           setIsLoading(false);
  //         }

  //     }

  const handleMultipleDelete_AVG = async (event) => {
    event.preventDefault();

    const selectedCustomers = selectedRows_US_Customer || [];
    const selectedIgnoredCustomers = selectedRows_US_IgnoredCustomer || [];
    const selectedRfid = selectedRows_US_Rfid || [];
    const selectedIgnoredRfid = selectedRows_US_IgnoredRfid || [];

    // Combine all selected IDs into one payload for avigiloncustomer_ids
    const avigiloncustomer_ids = [
      ...selectedCustomers,
      ...selectedIgnoredCustomers,
      ...selectedRfid,
      ...selectedIgnoredRfid,
    ];

    const avigiloncustomer_ids_arr = [];
    const tp_ids_arr = [];
    const tp_credentialids_arr = [];
    const tp_groupids_arr = [];

    const dataSources = [
      { selected: selectedRows_US_Customer, data: missingavigilonCustomer },
      { selected: selectedRows_US_Rfid, data: missmatchedRfid },
      { selected: selectedRows_US_IgnoredRfid, data: listUSRfidIgnored },
      { selected: selectedRows_US_IgnoredCustomer, data: listUS_CustomerIgnored }
    ];

    // Iterate over data sources to find the matching customer data
    dataSources.forEach(({ selected, data }) => {
      if (selected.length > 0) {
        avigiloncustomer_ids.forEach((avigilon_id) => {
          const customerData = data.find((customer) => customer.avigiloncustomer_id === avigilon_id);

          if (!customerData) {
            console.error(`Customer data not found for customer ID: ${avigilon_id}`);
            return; // Skip if no matching data found
          }

          avigiloncustomer_ids_arr.push(customerData.avigiloncustomer_id);
          if (customerData.tp_id) tp_ids_arr.push(customerData.tp_id);
          if (customerData.tp_credentialid) tp_credentialids_arr.push(customerData.tp_credentialid);
          if (customerData.tp_groupid) tp_groupids_arr.push(...customerData.tp_groupid);
        });
      }
    });

    const payload = {
      avigiloncustomer_ids: avigiloncustomer_ids_arr,
      admin_id: admin_id, // Ensure this is set properly
      tp_ids: tp_ids_arr,
      tp_credentialids: tp_credentialids_arr,
      tp_groupids: tp_groupids_arr,
    };

    console.log("Formatted payload for multiple delete:", payload);

    setIsLoading(true); // Set loading state earlier

    try {
      const response = await post('multipledelete_avigilon_customerdata', payload);
      if (response.status === 200) {
        toast.success("Selected customers were successfully deleted.");
        setopenCheckedIgnoreModal_AVG_MultipleDelete(false);
      } else {
        toast.error("An error occurred while deleting the customers. Please try again.");
      }
      settriggerReload(!triggerReload);
    } catch (error) {
      console.error("Error while deleting customers:", error);
      toast.error("An error occurred while processing your request.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMultipleAdd_AVG = async (event) =>{
    event.preventDefault();


    const selectedCustomers = selectedRows_US_Customer || [];
    const selectedIgnoredCustomers = selectedRows_US_IgnoredCustomer || [];
    const selectedRfid = selectedRows_US_Rfid || [];
    const selectedIgnoredRfid = selectedRows_US_IgnoredRfid || [];

    // Combine all selected customer data
    const selectedData = [
      ...selectedCustomers,
      ...selectedIgnoredCustomers,
      ...selectedRfid,
      ...selectedIgnoredRfid,
    ];

    // Prepare the payload structure based on the API requirements
    const customers = [];

    const dataSources = [
      { selected: selectedRows_US_Customer, data: missingavigilonCustomer },
      { selected: selectedRows_US_Rfid, data: missmatchedRfid },
      { selected: selectedRows_US_IgnoredRfid, data: listUSRfidIgnored },
      { selected: selectedRows_US_IgnoredCustomer, data: listUS_CustomerIgnored }
    ];

    // Extract customer data from the data sources
    dataSources.forEach(({ selected, data }) => {
      if (selected.length > 0) {
        selected.forEach((customerId) => {
          const customerData = data.find((customer) => customer.avigiloncustomer_id === customerId);

          if (!customerData) {
            console.error(`Customer data not found for customer ID: ${customerId}`);
            return; // Skip if no matching data found
          }

          // Structure the customer data as per the API requirements
          const newCustomer = {
            first_name: customerData.first_name,
            last_name: customerData.last_name,
            mobile: customerData.mobile,
            email: customerData.email,
            rfid: customerData.rfid,
            tp_id: customerData.tp_id,
            tp_credentialid: customerData.tp_credentialid,
            tp_groupid: customerData.tp_groupid,
            access_group: customerData.access_group
          };

          customers.push(newCustomer);
        });
      }
    });

    const payload = {
      customers,
    };

    setIsLoading(true); // Show loading state

    try {
      const response = await post('avigilon_multiple_addcustomer', payload); 
      if (response.status === 200) {
        toast.success("Selected customers were successfully added.");
        setopenCheckedIgnoreModal_AVG_MultipleAdd(false);
      } else {
        toast.error("An error occurred while adding the customers. Please try again.");
      }
      settriggerReload(!triggerReload); 
    } catch (error) {
      console.error("Error while adding customers:", error);
      toast.error("An error occurred while processing your request.");
    } finally {
      setIsLoading(false); 
    }

  }


  const handle_US_CustomerAddFunction = async (event, customerData) => {
    event.preventDefault();


    const data = {
      first_name: customerData.first_name,
      last_name: customerData.last_name,
      mobile: customerData.mobile,
      email: customerData.email,
      rfid: customerData.rfid,
      tp_id: customerData.tp_id,
      tp_credentialid: customerData.tp_credentialid,
      tp_groupid: customerData.tp_groupid || [], // default to empty array if missing
      access_group: customerData.access_group,
    }

    console.log("customerData::", data);

    try {
      // Show a loader or some indicator if needed
      setIsLoading(true);

      // Assuming you have a 'post' function set up for API calls
      const response = await post('avigilon_addcustomer', data);

      // Handle success
      if (response.status === 200) {
        toast.success("Customer added successfully!");

        // If you need to reload data or reset some state
        settriggerReload(!triggerReload);
      } else {
        toast.error("An error occurred while adding the customer. Please try again.");
      }
    } catch (error) {
      console.error("Error while adding customer:", error);
      toast.error("An error occurred while processing your request.");
    } finally {
      // Hide loader or indicator
      setIsLoading(false);
    }

  }




  return (
    <React.Fragment>
      <ToastContainer />
      <Box sx={{ display: "flex" }}>
        <Sidebar />

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <div className="App">
            <div className="d-flex align-items-center justify-content-between mb-3">

              <h3 className="heading-style" style={{
                fontSize: '1.5rem',
                fontWeight: '500'
              }}>UNSYNCED AVIGILON CUSTOMERS</h3>

              <div className="d-flex align-items-center">
              <Button className="reports-sync-btns me-4" variant="outlined">
                <img src={syncIcon} alt="sync" className="me-2" style={{width: '18px'}} />
             <span>Sync </span> </Button>
                {/* Show the Add button if any of the conditions are true */}
                {(
                  selectedRows_US_Customer.length > 1 ||
                  selectedRows_US_Rfid.length > 1 ||
                  selectedRows_US_IgnoredCustomer.length > 1 ||
                  selectedRows_US_IgnoredRfid.length > 1
                ) && (
                    <Button className="reports-addAV-btns me-4" variant="outlined" onClick={handleCheckedData_AVG_MultipleAdd}>
                       <img src={addIcon} alt="ignore" className="me-2" />
                       <span style={{marginTop: '3px'}}>Add </span> </Button>
                  )}


                {selectedRows_US_Customer.length > 1 && (
                  <Button className="reports-ignore-btns me-4" variant="outlined" onClick={handleCheckedData_AVG}>
                    <img src={ignoreIcon} alt="ignore" className="me-2" style={{width: '20px'}} />
                    <span>Ignore </span> </Button>
                )}
                {selectedRows_US_Rfid.length > 1 && (
                  <Button className="reports-ignore-btns me-4" variant="outlined" onClick={handleCheckedData_AVG_Rfid}>
                    <img src={ignoreIcon} alt="ignore" className="me-2" style={{width: '20px'}} />
                    <span>Ignore </span> </Button>
                )}
                {selectedRows_US_IgnoredCustomer.length > 1 && (
                  <Button className="reports-ignoreRedo-btns me-4" variant="outlined" onClick={handleCheckedData_AVG_IgnoredCustomer}>
                    <img src={redoIcon} alt="ignore" className="me-2" style={{width: '20px'}} />
                    <span>Redo </span> </Button>
                )}
                {selectedRows_US_IgnoredRfid.length > 1 && (
                  <Button className="reports-ignoreRedo-btns me-4" variant="outlined" onClick={handleCheckedData_AVG_IgnoredRfid}>
                    <img src={redoIcon} alt="ignore" className="me-2" style={{width: '20px'}} />
                    <span>Redo </span></Button>
                )}


                {/* Show the Delete button if any of the conditions are true */}
                {(
                  selectedRows_US_Customer.length > 1 ||
                  selectedRows_US_Rfid.length > 1 ||
                  selectedRows_US_IgnoredCustomer.length > 1 ||
                  selectedRows_US_IgnoredRfid.length > 1
                ) && (
                    <div className="tooltip2 ms-2" title="Delete">
                      <Button
                        className=" text-capitalize"
                        onClick={handleCheckedData_AVG_MultipleDelete}
                        variant="outlined"
                        style={{
                          padding: "6px 8px",
                          minWidth: "60px",
                          textAlign: "center",
                          borderRadius: "20px",
                          marginRight: "23px",
                          border: "1px solid #ff0000",
                          cursor: "pointer",
                          color: '#ff0000'
                        }}
                      >
                        {/* <SvgIcon fontSize="medium"> */}
                        <img src={deleteIconRed} alt="delete" className="me-2" style={{width: '20px'}} />
                        <span>Delete </span>
                        
                        {/* <DeleteOutlineIcon /> */}
                        {/* </SvgIcon>{" "} */}
                      </Button>
                    </div>
                  )}


              </div>


            </div>
          </div>
          <div style={{ background: '#fff', padding: '12px 10px', borderRadius: '15px' }}>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange} aria-label="lab API tabs example">
                    <Tab
                      label="AVIGILON CUSTOMERS" value="1" />
                    <Tab
                      label="UNSYNCED CUSTOMER DATA" value="2" />
                    <Tab

                      label="UNSYNCED RFID" value="3" />

                    <Tab

                      label="CUSTOMERS IGNORED" value="4" />

                  </TabList>
                </Box>

                {isLoading ? (
                  <div
                    className="table-style"
                    style={{ marginLeft: "46%", marginTop: "20%" }}
                  >
                    <PulseLoader
                      color="#02487B"
                      height={29}
                      margin={4}
                      radius={24}
                      width={4}
                    />
                    <p style={{ fontWeight: "bold", color: "#02487B" }}>
                      Loading
                    </p>
                  </div>
                ) : (
                  <>
                      <div className="d-flex justify-content-end align-items-end mt-2">
                        <input
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{ width: "290px" }}
                          className="me-4 search-style"
                        />
                        </div>

                    <TabPanel value="1">
                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                            >

                              {/* <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '5%' }}
                              >
                                {" "}
                              </TableCell> */}


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '5%' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ width: '19%' }}
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ width: '19%' }}
                              >
                                {"Last Name"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '19%' }}
                              >
                                {"Email"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '19%' }}
                              >
                                {"RFID"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '19%' }}
                              >
                                {"Access Group"}
                              </TableCell>



                            </TableRow>

                            {/* {avigilonCustomer.map((row, index) => ( */}
                            {avigilonCustomer
                            .filter((row) =>
                              Object.values(row).some((value) =>
                                value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                              )
                            )
                            .slice((currentPage_AVG_Customer - 1) * rowsPerPage_AVG_Customer, currentPage_AVG_Customer * rowsPerPage_AVG_Customer)
                            .map((row, index) => (
                                <TableRow key={index} sx={{ height: "23px" }}>
                                  
                                  {/* Delete button column */}
                                  <TableCell
                                    align="center"
                                    className={index % 2 === 0 ? "white-background" : "bg-table-blue"}
                                  >
                                    <div>
                                      <a href="#" className="text-danger" title="Delete">
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>

                                  {/* Render data from API */}
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.first_name}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.last_name}
                                  </TableCell>
                                  {/* Other fields like email, access_group, and RFID */}
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.email}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.rfid}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.access_group}
                                  </TableCell>


                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <Button onClick={handlePreviousPage_AVG_Customer} disabled={currentPage_AVG_Customer === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_AVG_Customer} disabled={currentPage_AVG_Customer === totalPage_AVG_Customer}>
                            Next
                          </Button>
                        </div>


                        {/* Display the range of items and total count */}
                        {/* {avigilonCustomer.length > 1 && ( */}
                        {/* {avigilonCustomer.length > 1 && ( */}
                        {filteredData_AVGCustomerList.length > 1 && (
                          <div className="page-info">
                            {/* {startIndex_AVG_Customer}-{endIndex_AVG_Customer} out of {avigilonCustomer.length} */}
                            {startIndex_AVG_Customer}-{endIndex_AVG_Customer} out of {filteredData_AVGCustomerList.length}
                          </div>
                        )}
                      </div>
                    </TabPanel>

                    {/* Missing avigilon customer tab */}
                    <TabPanel value="2">
                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                            >

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '5%' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '5%' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"Last Name"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"Email"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"RFID"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"Access Group"}
                              </TableCell>

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '2%' }}
                              >
                                {" "}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '3%' }}
                              >
                                {" "}
                              </TableCell>



                            </TableRow>

                            {/* {missingavigilonCustomer.map((row, index) => ( */}
                            {missingavigilonCustomer
                            .filter((row) =>
                              Object.values(row).some((value) =>
                                value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                              )
                            )
                            .slice((currentPage_AVG_US_Customer - 1) * rowsPerPage_AVG_US_Customer, currentPage_AVG_US_Customer * rowsPerPage_AVG_US_Customer)
                            .map((row, index) => (
                                <TableRow key={index} sx={{ height: "23px" }}>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_US_Customer.includes(row.avigiloncustomer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChange_US_Customer(event, row.avigiloncustomer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>
                                  {/* Delete button column */}
                                  <TableCell
                                    align="center"
                                    className={index % 2 === 0 ? "white-background" : "bg-table-blue"}
                                  >
                                    <div>
                                      <a href="#"
                                        className="text-danger"
                                        title="Delete"
                                        onClick={(event) => handleDeleteReport_AV_WCustomer(event, row)}
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>

                                  {/* Render data from API */}
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.first_name}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.last_name}
                                  </TableCell>
                                  {/* Other fields like email, access_group, and RFID */}
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.email}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.rfid}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.access_group}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-ignore-btns" disabled={selectedRows_US_Customer.length > 0} variant="outlined" onClick={() => handle_US_CustomerIgnoreFunction(row.avigiloncustomer_id, "customer_unsync")}>Ignore</Button>
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-addAV-btns" variant="outlined" onClick={(e) => handle_US_CustomerAddFunction(e, row)}>Add</Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>

                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <Button onClick={handlePreviousPage_AVG_US_Customer} disabled={currentPage_AVG_US_Customer === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_AVG_US_Customer} disabled={currentPage_AVG_US_Customer === totalPage_AVG_US_Customer}>
                            Next
                          </Button>
                        </div>


                        {/* Display the range of items and total count */}
                        {filteredDataMissingAVG.length > 1 && (
                          <div className="page-info">
                            {startIndex_AVG_US_Customer}-{endIndex_AVG_US_Customer} out of {filteredDataMissingAVG.length}
                          </div>
                        )}
                      </div>


                    </TabPanel>
                    {/* Missing avigilon customer tab Ends */}

                    {/* unsynced rfid customer tab */}
                    <TabPanel value="3">
                      <TableContainer component={Paper} className="">
                        <Table aria-label="collapsible table">

                          <TableBody>
                            <TableRow
                              className={"bg-table-blue_head"}
                              sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                            >

                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '5%' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '5%' }}
                              >
                                {" "}
                              </TableCell>


                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"First Name"}
                              </TableCell>
                              <TableCell
                                className={"bg-table-blue_head"}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"Last Name"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"Email"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"RFID"}
                              </TableCell>


                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '17%' }}
                              >
                                {"Access Group"}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '2%' }}
                              >
                                {" "}
                              </TableCell>
                              <TableCell
                                className={'bg-table-blue_head'}
                                component="th"
                                scope="row"
                                sx={{ width: '3%' }}
                              >
                                {" "}
                              </TableCell>



                            </TableRow>

                            {/* {missmatchedRfid.map((row, index) => ( */}
                            {missmatchedRfid
                            .filter((row) =>
                              Object.values(row).some((value) =>
                                value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                              )
                            )
                            .slice((currentPage_AVG_US_Rfid - 1) * rowsPerPage_AVG_US_Rfid, currentPage_AVG_US_Rfid * rowsPerPage_AVG_US_Rfid)
                            .map((row, index) => (
                                <TableRow key={index} sx={{ height: "23px" }}>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Checkbox
                                      checked={selectedRows_US_Rfid.includes(row.avigiloncustomer_id)}
                                      sx={{
                                        '& .MuiSvgIcon-root': {
                                          fontSize: 22, // Smaller size
                                          transform: 'scale(0.75)' // Scale down the checkbox
                                        }
                                      }}
                                      onChange={(event) => handleCheckboxChange_US_Rfid(event, row.avigiloncustomer_id)}
                                      inputProps={{ 'aria-label': 'select all' }}
                                    />
                                  </TableCell>
                                  {/* Delete button column */}
                                  <TableCell
                                    align="center"
                                    className={index % 2 === 0 ? "white-background" : "bg-table-blue"}
                                  >
                                    <div>
                                      <a href="#"
                                        className="text-danger"
                                        title="Delete"
                                        // onClick={(event) => handleDeleteReport_AV_WRfid(event,row)}
                                        onClick={(event) => handleDeleteReport_AV_WCustomer(event, row)}
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </a>
                                    </div>
                                  </TableCell>

                                  {/* Render data from API */}
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.first_name}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.last_name}
                                  </TableCell>
                                  {/* Other fields like email, access_group, and RFID */}
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.email}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.rfid}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    {row.access_group}
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-ignore-btns" variant="outlined" disabled={selectedRows_US_Rfid.length > 0} onClick={() => handle_US_RfidIgnoreFunction(row.avigiloncustomer_id, "rfid_unsync")}>Ignore</Button>
                                  </TableCell>
                                  <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                    <Button className="reports-addAV-btns" variant="outlined" onClick={(e) => handle_US_CustomerAddFunction(e, row)}>Add</Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <Button onClick={handlePreviousPage_AVG_US_Rfid} disabled={currentPage_AVG_US_Rfid === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_AVG_US_Rfid} disabled={currentPage_AVG_US_Rfid === totalPage_AVG_US_Rfid}>
                            Next
                          </Button>
                        </div>


                        {/* Display the range of items and total count */}
                        {/* {missmatchedRfid.length > 1 && ( */}
                        {filteredData_missingRfid.length > 1 && (
                          <div className="page-info">
                            {/* {startIndex_AVG_US_Rfid}-{endIndex_AVG_US_Rfid} out of {missmatchedRfid.length} */}
                            {startIndex_AVG_US_Rfid}-{endIndex_AVG_US_Rfid} out of {filteredData_missingRfid.length}
                          </div>
                        )}
                      </div>
                    </TabPanel>
                    {/* unsynced rfid customer tab Ends */}

                    <TabPanel value="4">

                      <div className="accordian-border">


                        {/* Accordian For UNSYNCED CUSTOMER DATA */}
                        <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '30px',  // Style for the icon
                                  color: '#1998f0 !important',  // Color for the icon
                                  marginRight: '10px'
                                }}
                              />
                            }
                            aria-controls="panel1-content"
                            id="panel1-header"
                            sx={{
                              flexDirection: 'row-reverse',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#004a7d !important',  // Color for the text
                              }}
                            >
                              UNSYNCED CUSTOMER DATA
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>

                            <TableContainer component={Paper} className="">
                              <Table aria-label="collapsible table">

                                <TableBody>
                                  <TableRow
                                    className={"bg-table-blue_head"}
                                    sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                                  >

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '5%' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '5%' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"First Name"}
                                    </TableCell>
                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"Last Name"}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"Email"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"RFID"}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"Access Group"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '5%' }}
                                    >
                                      {" "}
                                    </TableCell>



                                  </TableRow>
                                  {listUS_CustomerIgnored?.length > 0 ? (
                                    listUS_CustomerIgnored
                                    .filter((row) =>
                                      Object.values(row).some((value) =>
                                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                      )
                                    )
                                    .slice((currentPage_AVG_US_Ignored - 1) * rowsPerPage_AVG_US_Ignored_Customer, currentPage_AVG_US_Ignored * rowsPerPage_AVG_US_Ignored_Customer)
                                    ?.map((row, index) => (
                                      <TableRow key={index} sx={{ height: "23px" }}>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Checkbox
                                            checked={selectedRows_US_IgnoredCustomer.includes(row.avigiloncustomer_id)}
                                            sx={{
                                              '& .MuiSvgIcon-root': {
                                                fontSize: 22, // Smaller size
                                                transform: 'scale(0.75)' // Scale down the checkbox
                                              }
                                            }}
                                            onChange={(event) => handleCheckboxChange_US_IgnoredCustomer(event, row.avigiloncustomer_id)}
                                            inputProps={{ 'aria-label': 'select all' }}
                                          />
                                        </TableCell>
                                        {/* Delete button column */}
                                        <TableCell
                                          align="center"
                                          className={index % 2 === 0 ? "white-background" : "bg-table-blue"}
                                        >
                                          <div>
                                            <a href="#"
                                              className="text-danger"
                                              title="Delete"
                                              onClick={(event) => handleDeleteReport_AV_WCustomer(event, row)}
                                            >
                                              <img src={deleteIcon} alt="delete" />
                                            </a>
                                          </div>
                                        </TableCell>

                                        {/* Render data from API */}
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.first_name}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.last_name}
                                        </TableCell>
                                        {/* Other fields like email, access_group, and RFID */}
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.email}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.rfid}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.access_group}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Button className="reports-ignoreRedo-btns" variant="outlined" onClick={() => handleRedoUS_CustomerFunction(row.avigiloncustomer_id, "customer_unsync")}>Redo</Button>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={8} align="center">
                                        <span className="no-data-text">No data found</span>
                                      </TableCell>
                                    </TableRow>
                                  )}

                                </TableBody>
                              </Table>
                            </TableContainer>

                        <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <Button onClick={handlePreviousPage_AVG_US_Ignored_Customer} disabled={currentPage_AVG_US_Ignored === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_AVG_US_Ignored_Customer} disabled={currentPage_AVG_US_Ignored === totalPage_AVG_US_Ignored_Customer}>
                            Next
                          </Button>
                        </div>


                        {/* Display the range of items and total count */}
                        {/* {listUS_CustomerIgnored.length > 1 && ( */}
                        {filteredData_AVG_Ignored_US_customer.length > 1 && (
                          <div className="page-info">
                            {/* {startIndex_AVG_US_Ignored_Customer}-{endIndex_AVG_US_Ignored_Customer} out of {listUS_CustomerIgnored.length} */}
                            {startIndex_AVG_US_Ignored_Customer}-{endIndex_AVG_US_Ignored_Customer} out of {filteredData_AVG_Ignored_US_customer.length}
                          </div>
                        )}
                      </div>


                          </AccordionDetails>
                        </Accordion>

                        {/* Accordian For UNSYNCED RFID Customers */}
                        <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                sx={{
                                  fontSize: '30px',  // Style for the icon
                                  color: '#1998f0 !important',  // Color for the icon
                                  marginRight: '10px'
                                }}
                              />
                            }
                            aria-controls="panel1-content"
                            id="panel1-header"
                            sx={{
                              flexDirection: 'row-reverse',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#004a7d !important',  // Color for the text
                              }}
                            >
                              UNSYNCED RFID
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>

                            <TableContainer component={Paper} className="">
                              <Table aria-label="collapsible table">

                                <TableBody>
                                  <TableRow
                                    className={"bg-table-blue_head"}
                                    sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                                  >

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '5%' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '5%' }}
                                    >
                                      {" "}
                                    </TableCell>


                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"First Name"}
                                    </TableCell>
                                    <TableCell
                                      className={"bg-table-blue_head"}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"Last Name"}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"Email"}
                                    </TableCell>
                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"RFID"}
                                    </TableCell>


                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '17%' }}
                                    >
                                      {"Access Group"}
                                    </TableCell>

                                    <TableCell
                                      className={'bg-table-blue_head'}
                                      component="th"
                                      scope="row"
                                      sx={{ width: '5%' }}
                                    >
                                      {" "}
                                    </TableCell>



                                  </TableRow>
                                  {listUSRfidIgnored?.length > 0 ? (
                                    listUSRfidIgnored
                                    .filter((row) =>
                                      Object.values(row).some((value) =>
                                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                      )
                                    )
                                    .slice((currentPage_AVG_US_Ignored_Rfid - 1) * rowsPerPage_AVG_US_Ignored_Rfid, currentPage_AVG_US_Ignored_Rfid * rowsPerPage_AVG_US_Ignored_Rfid)
                                    ?.map((row, index) => (
                                      <TableRow key={index} sx={{ height: "23px" }}>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Checkbox
                                            checked={selectedRows_US_IgnoredRfid.includes(row.avigiloncustomer_id)}
                                            sx={{
                                              '& .MuiSvgIcon-root': {
                                                fontSize: 22, // Smaller size
                                                transform: 'scale(0.75)' // Scale down the checkbox
                                              }
                                            }}
                                            onChange={(event) => handleCheckboxChange_US_IgnoredRfid(event, row.avigiloncustomer_id)}
                                            inputProps={{ 'aria-label': 'select all' }}
                                          />
                                        </TableCell>
                                        {/* Delete button column */}
                                        <TableCell
                                          align="center"
                                          className={index % 2 === 0 ? "white-background" : "bg-table-blue"}
                                        >
                                          <div>
                                            <a href="#"
                                              className="text-danger"
                                              title="Delete"
                                              onClick={(event) => handleDeleteReport_AV_WCustomer(event, row)}
                                            >
                                              <img src={deleteIcon} alt="delete" />
                                            </a>
                                          </div>
                                        </TableCell>

                                        {/* Render data from API */}
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.first_name}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.last_name}
                                        </TableCell>
                                        {/* Other fields like email, access_group, and RFID */}
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.email}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.rfid}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          {row.access_group}
                                        </TableCell>
                                        <TableCell className={index % 2 === 0 ? "white-background" : "bg-table-blue"}>
                                          <Button className="reports-ignoreRedo-btns" variant="outlined" onClick={() => handleRedoUS_RfidFunction(row.avigiloncustomer_id, "rfid_unsync")}>Redo</Button>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={8} align="center">
                                        <span className="no-data-text">No data found</span>
                                      </TableCell>
                                    </TableRow>
                                  )}


                                  {/* ))} */}

                                </TableBody>
                              </Table>
                            </TableContainer>

                        <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <Button onClick={handlePreviousPage_AVG_US_Ignored_Rfid} disabled={currentPage_AVG_US_Ignored_Rfid === 1}>
                            Previous
                          </Button>
                          <Button onClick={handleNextPage_AVG_US_Ignored_Rfid} disabled={currentPage_AVG_US_Ignored_Rfid === totalPage_AVG_US_Ignored_Rfid}>
                            Next
                          </Button>
                        </div>


                        {/* Display the range of items and total count */}
                        {/* {listUSRfidIgnored.length > 1 && ( */}
                        {filteredData_AVG_Ignored_US_Rfid.length > 1 && (
                          <div className="page-info">
                            {/* {startIndex_AVG_US_Ignored_Rfid}-{endIndex_AVG_US_Ignored_Rfid} out of {listUSRfidIgnored.length} */}
                            {startIndex_AVG_US_Ignored_Rfid}-{endIndex_AVG_US_Ignored_Rfid} out of {filteredData_AVG_Ignored_US_Rfid.length}
                          </div>
                        )}
                      </div>


                          </AccordionDetails>
                        </Accordion>
                      </div>

                    </TabPanel>

                  </>
                )}

                {/* <Modal
                  open={openCheckedIgnoreModal_AVG}
                  onClose={handleCheckedIgnoreClose_AVG}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Ignore</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_AVG} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <hr />
                    <form className="mt-4 mb-4">
                      <p>Are you sure you want to ignore all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_AVG_US_Customer_IgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_AVG}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal> */}

                {/* Ignore modal for US Rfid */}
                <ConformationModal
                  open={openCheckedIgnoreModal_AVG}
                  onClose={handleCheckedIgnoreClose_AVG}
                  onSubmitModal={handleChecked_AVG_US_Customer_IgnoreSubmit}
                  title="Ignore"
                  message="Are you sure you want to ignore all selected customers?"
                />

                {/* Ignore Modals */}
                <ConformationModal
                  open={openCheckedIgnoreModal_AVG_Rfid}
                  onClose={handleCheckedIgnoreClose_AVG_Rfid}
                  onSubmitModal={handleChecked_AVG_US_Rfid_IgnoreSubmit}
                  title="Ignore"
                  message="Are you sure you want to ignore all selected customers?"
                />

                {/* Ignore modal for US Rfid */}
                {/* <Modal
                  open={openCheckedIgnoreModal_AVG_Rfid}
                  onClose={handleCheckedIgnoreClose_AVG_Rfid}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Ignore</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_AVG_Rfid} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <hr />
                    <form className="mt-4 mb-4">
                      <p>Are you sure you want to ignore all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_AVG_US_Rfid_IgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_AVG_Rfid}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal> */}

                {/* redo modal for US Ignored customers */}
                {/* <Modal
                  open={openCheckedIgnoreModal_AVG_IgnoredCustomer}
                  onClose={handleCheckedIgnoreClose_AVG_IgnoredCustomer}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Redo</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_AVG_IgnoredCustomer} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <hr />
                    <form className="mt-4 mb-4">
                      <p>Are you sure you want to redo all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_AVG_US_IgnoredCustomer_IgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_AVG_IgnoredCustomer}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal> */}

                <ConformationModal
                  open={openCheckedIgnoreModal_AVG_IgnoredCustomer}
                  onClose={handleCheckedIgnoreClose_AVG_IgnoredCustomer}
                  title="Redo"
                  message="Are you sure you want to redo all selected customers?"
                  onSubmitModal={handleChecked_AVG_US_IgnoredCustomer_IgnoreSubmit}
                />

                <ConformationModal
                  open={openCheckedIgnoreModal_AVG_IgnoredRfid}
                  onClose={handleCheckedIgnoreClose_AVG_IgnoredRfid}
                  title="Redo"
                  message="Are you sure you want to redo all selected customers?"
                  onSubmitModal={handleChecked_AVG_US_IgnoredRfid_IgnoreSubmit}
                />

                {/* redo modal for US rfid Ignored customers */}
                {/* <Modal
                  open={openCheckedIgnoreModal_AVG_IgnoredRfid}
                  onClose={handleCheckedIgnoreClose_AVG_IgnoredRfid}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Redo</h6>
                      <IconButton onClick={handleCheckedIgnoreClose_AVG_IgnoredRfid} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <hr />
                    <form className="mt-4 mb-4">
                      <p>Are you sure you want to redo all selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={(event) => handleChecked_AVG_US_IgnoredRfid_IgnoreSubmit(event)}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleCheckedIgnoreClose_AVG_IgnoredRfid}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal> */}

                {/* w/o  Email Delete conformation modal */}

                <Modal
                  open={isModalOpen_Delete_AV_WCustomer}
                  onClose={handleDeleteModalClose_AV_WCustomer}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
                    borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Delete</h6>
                      <IconButton onClick={handleDeleteModalClose_AV_WCustomer} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to delete the selected customer?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={handleDelete_AVG}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleDeleteModalClose_AV_WCustomer}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal>

                {/* w/o  Email Delete conformation modal Ends*/}

                {/* w/o  Multiple Delete conformation modal */}

                {/* <Modal
                  open={openCheckedIgnoreModal_AVG_MultipleDelete}
                  onClose={handleDeleteModalClose_AV_MultipleDelete}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
                  borderBottom: '1px solid #cfcfcf' }}>
                      <h6 style={{ textAlign: 'left', margin: 0 }}>Delete</h6>
                      <IconButton onClick={handleDeleteModalClose_AV_MultipleDelete} size="small">
                        <CloseIcon />
                      </IconButton>
                    </div>
                    <form className="" style={{padding: '20px 21px'}}>
                      <p>Are you sure you want to delete the selected customers?</p>
                      <div className="text-end mt-2">
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="large"
                          className="me-4 btn-sty"
                          sx={{ mr: 2, ...buttonStyle }}
                          onClick={handleMultipleDelete_AVG}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="large"
                          className="btn-sty"
                          sx={buttonStyle}
                          onClick={handleDeleteModalClose_AV_MultipleDelete}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </Box>
                </Modal> */}

                <ConformationModal
                  open={openCheckedIgnoreModal_AVG_MultipleDelete}
                  onClose={handleDeleteModalClose_AV_MultipleDelete}
                  title="Delete"
                  message="Are you sure you want to delete the selected customers?"
                  onSubmitModal={handleMultipleDelete_AVG}
                />

                {/* w/o  Multiple Delete conformation modal Ends*/}

                {/* conformation modal for multiple add */}
                <ConformationModal
                  open={openCheckedIgnoreModal_AVG_MultipleAdd}
                  onClose={handleClose_MultipleAddModal}
                  title="Add"
                  message="Are you sure you want to add all selected customers?"
                  onSubmitModal={handleMultipleAdd_AVG}
                />
                {/* conformation modal for multiple add ends */}



              </TabContext>
            </Box>
          </div>
        </Box>
      </Box>
    </React.Fragment>
  );

}
export default AvigilonSync;